import { MemeGeneratorState } from "../types";

export const getHighestZIndexElement = (state: MemeGeneratorState): { id: string; zIndex: number } | undefined =>
    [...(state.meme?.textBoxes || []), ...(state.meme?.icons || [])].sort((t1, t2) =>
        t1.zIndex > t2.zIndex ? -1 : 1,
    )[0];
